import {
  type ForgotPasswordMutation,
  type ForgotPasswordMutationVariables,
  type MutationFunctionOptions,
  type MutationHookOptions,
  useForgotPasswordMutation,
} from "@qw/graphql";
import { useAuthContext } from "./use-auth-context";

type ForgotPasswordArgs = Omit<ForgotPasswordMutationVariables, "authClientId">;

export function useForgotPassword(
  options: MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables> = {}
) {
  const { authClientId } = useAuthContext();
  const [forgotPasswordMutation, result] = useForgotPasswordMutation(options);

  const forgotPassword = (mutationOptions: MutationFunctionOptions<ForgotPasswordMutation, ForgotPasswordArgs>) => {
    if (!mutationOptions.variables?.email) {
      return Promise.reject(new Error("email is required"));
    }

    return forgotPasswordMutation({
      ...mutationOptions,
      variables: { ...mutationOptions.variables, authClientId },
    });
  };

  return [forgotPassword, result] as const;
}
